import { sharedSelectors } from 'shared-lib'
import * as customerSelectors from './customer/customer.selectors'
import * as searchKeySelectors from './search-key/search-key.selectors'

export const selectors = { ...sharedSelectors, ...searchKeySelectors, ...customerSelectors }
